/* EDX 19/10/2026 · Vòng quay Khách mới. Dữ liệu từ sections/edx-vong-quay.liquid. Kết quả thật do Apps Script (edx.relay_url) quyết định; ?edx_thu=1 = thử tại máy. 19/10: gửi kèm nguồn khách (edxNguon).
   22/10 (Hỏi bé AI): không bật vòng quay khi hộp chat AI đang mở (đợi 20 giây rồi thử lại); khách đã để số Zalo trong hộp chat thì không bật nữa. */
(function () {
  if (window.edxVqReady) return; window.edxVqReady = true;
  var el = document.querySelector('[data-edx-vq-data]'), D = {};
  try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var P = D.prizes || [], dlg = document.querySelector('[data-edx-vq]');
  if (!dlg || P.length < 2) return;
  var test = /[?&]edx_thu=1/.test(location.search);
  if (!test && (!D.on || !D.relay)) return;
  if (!test && D.tpl === 'cart') return;
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  if (!test) {
    if (get('edx_vq_done')) return;
    var sn = parseInt(get('edx_vq_snooze') || '0', 10);
    if (sn && Date.now() < sn) return;
  }
  var COL = ['#efe7ff', '#fbf2ea', '#f4eefb', '#fff3dc'];
  var svg = dlg.querySelector('[data-edx-vq-svg]'), n = P.length, h = '';
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  for (var i = 0; i < n; i++) {
    var a0 = 2 * Math.PI * i / n - Math.PI / 2, a1 = 2 * Math.PI * (i + 1) / n - Math.PI / 2, am = (a0 + a1) / 2;
    var x0 = 100 + 100 * Math.cos(a0), y0 = 100 + 100 * Math.sin(a0), x1 = 100 + 100 * Math.cos(a1), y1 = 100 + 100 * Math.sin(a1);
    var tx = 100 + 62 * Math.cos(am), ty = 100 + 62 * Math.sin(am), rot = am * 180 / Math.PI + 90;
    var w = (P[i].ngan || P[i].ten).split(' '), l1 = w.slice(0, 2).join(' '), l2 = w.slice(2).join(' ');
    h += '<path d="M100,100 L' + x0.toFixed(1) + ',' + y0.toFixed(1) + ' A100,100 0 0 1 ' + x1.toFixed(1) + ',' + y1.toFixed(1) + ' Z" fill="' + COL[i % COL.length] + '" stroke="#c9a961" stroke-width="1"/>';
    h += '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '" transform="rotate(' + rot.toFixed(0) + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ')" text-anchor="middle" font-size="9" font-weight="700" fill="#22105f"><tspan x="' + tx.toFixed(1) + '" dy="-2">' + esc(l1) + '</tspan><tspan x="' + tx.toFixed(1) + '" dy="10">' + esc(l2) + '</tspan></text>';
  }
  svg.innerHTML = h;

  var shown = false, hoan = false;
  function show() {
    if (shown) return;
    if (document.querySelector('.edx-ai__b--ok')) return;
    if (document.querySelector('dialog.edx-ai[open]')) {
      if (!hoan) { hoan = true; setTimeout(function () { hoan = false; show(); }, 20000); }
      return;
    }
    shown = true;
    window.removeEventListener('scroll', onScroll);
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function onScroll() {
    var d = document.documentElement, p = (window.scrollY + window.innerHeight) / Math.max(1, d.scrollHeight) * 100;
    if (p >= (D.scroll || 40)) show();
  }
  if (test) setTimeout(show, 400);
  else { setTimeout(show, (D.delay || 15) * 1000); window.addEventListener('scroll', onScroll, { passive: true }); }

  var spun = false;
  function close() {
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    if (!spun && !test) set('edx_vq_snooze', String(Date.now() + (D.snooze || 7) * 86400000));
  }
  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-edx-vq-close]') || e.target === dlg) { close(); return; }
    var c = e.target.closest('[data-edx-vq-copy]');
    if (c) {
      var code = dlg.querySelector('[data-edx-vq-code]').textContent;
      try { navigator.clipboard.writeText(code); c.textContent = '✓ Đã chép'; } catch (err) {}
    }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  function pickLocal() {
    var t = 0, r, k;
    for (k = 0; k < n; k++) t += Number(P[k].w) || 0;
    r = Math.random() * t;
    for (k = 0; k < n; k++) { r -= Number(P[k].w) || 0; if (r < 0) return k; }
    return 0;
  }
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function spin(idx) {
    return new Promise(function (res) {
      var seg = 360 / n, mid = idx * seg + seg / 2, jitter = (Math.random() - 0.5) * seg * 0.6;
      var deg = calm ? 360 - mid : 360 * 6 + (360 - mid) + jitter;
      svg.style.transform = 'rotate(' + deg + 'deg)';
      setTimeout(res, calm ? 50 : 4300);
    });
  }
  function result(idx, sdt, again) {
    var p = P[idx] || {}, res = dlg.querySelector('[data-edx-vq-res]'), shop = dlg.querySelector('[data-edx-vq-shop]');
    dlg.querySelector('[data-edx-vq-form]').hidden = true;
    res.hidden = false;
    dlg.querySelector('[data-edx-vq-prize]').textContent = p.ten;
    if (p.ma) {
      dlg.querySelector('[data-edx-vq-codebox]').hidden = false;
      dlg.querySelector('[data-edx-vq-code]').textContent = p.ma;
      shop.href = '/discount/' + encodeURIComponent(p.ma) + '?redirect=' + encodeURIComponent(shop.getAttribute('href'));
    }
    dlg.querySelector('[data-edx-vq-note]').textContent = (again ? 'Số Zalo này đã quay trước đó. ' : '') + (p.note || '');
    spun = true;
    if (!test) {
      set('edx_vq_done', '1');
      try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Quà vòng quay': p.ten + ' · ' + sdt } }) }); } catch (e) {}
    }
    try { if (typeof window.gtag === 'function') window.gtag('event', 'vong_quay', { qua: p.ten, thu: test ? 1 : 0 }); } catch (e) {}
  }
  var form = dlg.querySelector('[data-edx-vq-form]'), err = dlg.querySelector('[data-edx-vq-err]'), btn = form.querySelector('button');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var s = (form.sdt.value || '').replace(/[^0-9+]/g, '').replace(/^\+?84/, '0');
    if (!/^0(3|5|7|8|9)\d{8}$/.test(s)) { err.textContent = 'Chị kiểm tra lại số Zalo giúp shop (10 số, bắt đầu bằng 0).'; err.hidden = false; form.sdt.focus(); return; }
    if (!form.dong_y.checked) { err.textContent = 'Chị đánh dấu đồng ý để shop nhắn Zalo gửi quà nhé.'; err.hidden = false; return; }
    err.hidden = true; btn.disabled = true; btn.textContent = 'Đang quay…';
    var job;
    if (test || !D.relay) job = Promise.resolve({ ok: true, o: pickLocal(), da_quay: false });
    else job = fetch(D.relay, { method: 'POST', body: JSON.stringify(Object.assign({ loai: 'vong_quay', sdt: s, trang: location.pathname, gio: new Date().toLocaleString('vi-VN') }, window.edxNguon ? window.edxNguon() : {})) })
      .then(function (r) { return r.json(); });
    job.then(function (r) {
      if (!r || !r.ok || typeof r.o !== 'number' || !P[r.o]) throw new Error((r && r.loi) || 'loi');
      return spin(r.o).then(function () { result(r.o, s, !!r.da_quay); });
    }).catch(function () {
      btn.disabled = false; btn.textContent = btn.getAttribute('data-l') || 'Quay nhận quà';
      err.textContent = 'Chưa quay được. Chị thử lại hoặc nhắn Zalo 098.106.4444 giúp shop nhé.'; err.hidden = false;
    });
  });
})();
